import { defineDirective } from "../../../utils/angular"

/** @internal */
export class PathCtrl {

    static create(): ng.IDirective {
        return defineDirective(PathCtrl, "shared/components/files/path/path.html", {
            "path": "<"
        })
    }

    private _path: string

    parts: string[]

    get path() {
        return this._path
    }

    set path(value) {
        this._path = value
        this.setup()
    }

    private setup() {
        this.parts = (this._path || "").split("/").filter(p => !!p)
    }

}
